// extracted by css-extract-rspack-plugin
module.exports =  {"storieswrap":"EZrHR","cardheading":"VLRNK","linkarrow":"z4IAH","links":"Wk3Np"};